import { RedoTextInput } from "@redotech/arbiter/input/redo-text-input";
import { groupInput, input, InputSchema } from "@redotech/ui/form";
import { nonEmptyValidator } from "@redotech/ui/validators";
import { memo } from "react";

export const PassportGlobalCarrierInput = groupInput({
  apiKey: input<string>({ validator: nonEmptyValidator }),
  companyName: input<string>({ validator: nonEmptyValidator }),
  email: input<string>({ validator: nonEmptyValidator }),
  name: input<string>({ validator: nonEmptyValidator }),
  phone: input<string>({ validator: nonEmptyValidator }),
});

export type PassportGlobalCarrierValue = InputSchema.Value<
  typeof PassportGlobalCarrierInput
>;

export type PassportGlobalCarrierForm = InputSchema.Input<
  typeof PassportGlobalCarrierInput
>;

export const PassportGlobalCarrierDefault = (): PassportGlobalCarrierValue => ({
  apiKey: "",
  companyName: "",
  email: "",
  name: "",
  phone: "",
});

export const CreatePassportGlobalCarrierForm = memo(
  function CreatePassportGlobalCarrierForm({
    carrierInput,
  }: {
    carrierInput: PassportGlobalCarrierForm;
  }) {
    return (
      <>
        <RedoTextInput
          label="API key"
          placeholder=""
          setValue={carrierInput.inputs.apiKey.setValue}
          value={carrierInput.inputs.apiKey.value}
        />
        <RedoTextInput
          label="Company name"
          placeholder=""
          setValue={carrierInput.inputs.companyName.setValue}
          value={carrierInput.inputs.companyName.value}
        />

        <RedoTextInput
          label="Email"
          placeholder=""
          setValue={carrierInput.inputs.email.setValue}
          value={carrierInput.inputs.email.value}
        />

        <RedoTextInput
          label="Name"
          placeholder=""
          setValue={carrierInput.inputs.name.setValue}
          value={carrierInput.inputs.name.value}
        />

        <RedoTextInput
          label="Phone"
          placeholder=""
          setValue={carrierInput.inputs.phone.setValue}
          value={carrierInput.inputs.phone.value}
        />
      </>
    );
  },
);
